export default {
    calendar: {
        items: [],
        workingHours: {}
    },
    orderInfo: {},
    bookableOnlyBySE360: false
};
